module.exports = __webpack_public_path__ + "static/media/portfolio-2.3d320571.jpg";